module.exports = __webpack_public_path__ + "img/border_triangle.9e3ee9d7.svg";